import {
  Bar,
  ComposedChart,
  Legend,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

export default function SugarInsulinChart({ data }) {
  return (
    <div className="rounded-2xl bg-white p-3">
      <h3 className="mb-2 text-2xl font-bold text-navy-900">🩸 起床 / 睡前血糖 × 胰島素劑量</h3>
      <p className="mb-2 text-lg text-gray-500">兩條折線是血糖，長條是胰島素，回診給醫師看更清楚</p>
      <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <XAxis dataKey="date" tick={{ fontSize: 14 }} />
          <YAxis yAxisId="sugar" tick={{ fontSize: 14 }} unit=" mg" />
          <YAxis yAxisId="insulin" orientation="right" tick={{ fontSize: 14 }} unit=" u" />
          <Tooltip labelStyle={{ fontSize: 16 }} contentStyle={{ fontSize: 18 }} />
          <Legend wrapperStyle={{ fontSize: 16 }} />
          <Bar yAxisId="insulin" dataKey="insulin_rapid" name="速效" fill="#dc2626" barSize={18} />
          <Bar yAxisId="insulin" dataKey="insulin_long" name="長效" fill="#f59e0b" barSize={18} />
          <ReferenceLine
            yAxisId="sugar"
            y={150}
            stroke="#e11d48"
            strokeDasharray="6 6"
            label={{ value: '目標 150', position: 'right', fontSize: 14, fill: '#e11d48' }}
          />
          <Line
            yAxisId="sugar"
            type="monotone"
            dataKey="morning_blood_sugar"
            name="起床血糖"
            stroke="#0ea5e9"
            strokeWidth={4}
            dot={{ r: 6 }}
          />
          <Line
            yAxisId="sugar"
            type="monotone"
            dataKey="bedtime_blood_sugar"
            name="睡前血糖"
            stroke="#0b1f3a"
            strokeWidth={4}
            dot={{ r: 6 }}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}
